import { render } from 'react-dom';

import Root from './components/Root';

const node = document.getElementById('root');

render(<Root />, node);
